import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";

export default function PageGate({ page, children, fallback = "/" }) {
  const { pages, ready } = useSite();
  const { user } = useAuth();
  const location = useLocation();
  if (!ready) return null;
  const preview = user?.admin && new URLSearchParams(location.search).get("preview") === "1";
  if (!pages[page] && !preview) return <Navigate to={fallback} replace />;
  return children;
}
